import React, { useEffect, useRef, useState } from 'react';
import styles from './accountSetting.module.css';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { addAdminuser, getAllAdminThunk, updateAdminPasswordThunk } from '../redux/admin/adminSlice';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye } from '@fortawesome/free-solid-svg-icons';
import NestedUserHeader from '../component/reusable/NestedUserHeader';
import api from '../utils/api';
import { toast } from 'react-toastify';
import { closeCircle } from '../Svg';
import { getProfile, updateAccountSettingsThunk, setLogout } from '../redux/userSlice';
import AccountSettingsTab from '../component/AccountSettingTab';

const AccountSetting = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const [isConfirmPasswordVisible, setConfirmPasswordVisible] = useState(false);
    const [currentPass, setCurrentPass] = useState(false);
    const thumbnailImageref = useRef();
    const { user } = useSelector((state) => state.user);
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const [loading, setLoading] = useState(false)
    const [selectedTab, setSelectedTab] = useState(0)
    const [data, setData] = useState([])

    const handleLogout = () => {
        localStorage.clear();
        dispatch(setLogout());
        window.location.href = '/';
    };

    // General Information Formik
    const generalFormik = useFormik({
        initialValues: {
            name: user?.name || '',
            phone: user?.phone || '',
            email: user?.email || '',
            recoveryEmail: user?.recoveryEmail || '',
            profileImg: user?.profileImg || [],
        },
        enableReinitialize: true,
        validationSchema: Yup.object({
            name: Yup.string().required('Name is required'),
            phone: Yup.string().required('Phone number is required'),
            email: Yup.string().email('Invalid email').required('Email is required'),
            recoveryEmail: Yup.string().email('Invalid email').required('Recovery email is required'),
        }),
        onSubmit: async (values) => {
            await dispatch(updateAccountSettingsThunk(values));
        },
    });

    // Password Update Formik
    const passwordFormik = useFormik({
        initialValues: {
            currentPassword: '',
            password: '',
            confirmPassword: '',
        },
        validationSchema: Yup.object({
            currentPassword: Yup.string().required('Current password is required'),
            password: Yup.string().required('Password is required'),
            confirmPassword: Yup.string()
                .oneOf([Yup.ref('password'), null], 'Passwords must match')
                .required('Confirm password is required'),
        }),
        onSubmit: async (values) => {
            const data = {
                id: user?._id,
                values
            }
            const result = await dispatch(updateAdminPasswordThunk(data))
            if (updateAdminPasswordThunk.fulfilled.match(result) && result.payload?.isCurrentUser) {
                setShowSuccessModal(true);
            }
        },
    });

    const handleImageChange = async (e, attribute, repo) => {

        const file = e.target?.files?.[0] || e.dataTransfer?.files?.[0];

        const maxSize = 1 * 1024 * 1024; // 1MB

        if (file.size > maxSize) {
            toast.error("File size should not exceed 1MB");
            return;
        }

        setLoading(true)
        try {
            if (file) {
                const body = new FormData()
                body.append('image', file)
                body.append("repo", `admin/${repo}`)

                const { data, status } = await api.fileUpload(body)

                if (status === 200) {
                    generalFormik.setFieldValue(attribute, data.data)
                }
            }
        } catch (err) {
            console.log(err);
            toast.error("Error uploading file")
        } finally {
            setLoading(false)
        }
    };


    const handleRemove = (repo) => {
        generalFormik.setFieldValue(repo, '');
    };


    const getAllPermissions = async () => {
        try {
            const { data, status } = await api.getAdminPermissions()
            if (data) {
                setData(data?.data?.adminPermissions)
            }
        } catch (err) {
            console.log(err);
        }
    }


    useEffect(() => {
        getAllPermissions()
    }, [])


    const updatePermission = async (permission) => {
        let adminPermissions = []
        const isExist = data?.includes(permission)
        if (isExist) {
            adminPermissions = data?.filter(i => i != permission)
        } else {
            adminPermissions = [...data, permission]
        }
        try {
            const finaldata = {
                adminPermissions: adminPermissions
            }
            const { data, status } = await api.updateAdminPermissions(finaldata)
            if (data) {
                toast.success("permission updated successfully")
                getAllPermissions()
            }
        } catch (err) {
            console.log(err);
            toast.error(err?.response?.data?.message || "something went wrong")
        }

    }

    return (
        <>
            <NestedUserHeader
                index="Account Settings"
                root="admins"
                buttonText={'Back to list'} />



            <div className={styles.updateCategoryContainer}>
                <div className={styles.genaralInfo} style={{ width: '65%' }}>
                    {user?.type == "SUPERADMIN" &&
                        <AccountSettingsTab handleChange={(event, newValue) => setSelectedTab(newValue)} selectedTab={selectedTab} />
                    }
                    {selectedTab == 0 ?
                        <>
                            <div className={styles.card}>
                                <h2 className={styles.addCatH2}>General info</h2>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Full name
                                        <input
                                            type="text"
                                            name="name"
                                            placeholder="Full name"
                                            className={styles.addCatInput}
                                            onChange={generalFormik.handleChange}
                                            onBlur={generalFormik.handleBlur}
                                            value={generalFormik.values.name}
                                        />
                                        {generalFormik.touched.name && generalFormik.errors.name && (
                                            <div className={styles.errorText}>{generalFormik.errors.name}</div>
                                        )}
                                    </label>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Email id
                                        <input
                                            type="email"
                                            name="email"
                                            placeholder="Enter"
                                            className={styles.addCatInput}
                                            onChange={generalFormik.handleChange}
                                            onBlur={generalFormik.handleBlur}
                                            value={generalFormik.values.email}
                                        />
                                        {generalFormik.touched.email && generalFormik.errors.email && (
                                            <div className={styles.errorText}>{generalFormik.errors.email}</div>
                                        )}
                                    </label>
                                </div>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Phone number
                                        <input
                                            type="phone"
                                            name="phone"
                                            placeholder="Enter"
                                            className={styles.addCatInput}
                                            onChange={generalFormik.handleChange}
                                            onBlur={generalFormik.handleBlur}
                                            value={generalFormik.values.phone}
                                        />
                                        {generalFormik.touched.phone && generalFormik.errors.phone ? (
                                            <div className={styles.errorText}>{generalFormik.errors.phone}</div>
                                        ) : null}
                                    </label>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Recovery email id
                                        <input
                                            type="email"
                                            name="recoveryEmail"
                                            placeholder="Enter"
                                            className={styles.addCatInput}
                                            onChange={generalFormik.handleChange}
                                            onBlur={generalFormik.handleBlur}
                                            value={generalFormik.values.recoveryEmail}
                                        />
                                        {generalFormik.touched.recoveryEmail && generalFormik.errors.recoveryEmail ? (
                                            <div className={styles.errorText}>{generalFormik.errors.recoveryEmail}</div>
                                        ) : null}
                                    </label>
                                </div>
                                <button type="submit" className={styles.darkButtons} onClick={generalFormik.handleSubmit} disabled={generalFormik.isSubmitting}>{generalFormik.isSubmitting ? 'please wait' : "Edit details"}
                                </button>
                            </div>
                            {/* <form onSubmit={passwordFormik.handleSubmit} className={styles.updateCategoryContainer}> */}
                            <div className={styles.card}>
                                <h2 className={styles.addCatH2}>Update Password</h2>
                                <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                    Old password
                                    <div className={styles.logininputContainer}>
                                        <input
                                            type={currentPass ? 'text' : 'password'}
                                            name="currentPassword"
                                            placeholder="********"
                                            className={styles.addCatInput}
                                            onChange={passwordFormik.handleChange}
                                            onBlur={passwordFormik.handleBlur}
                                            value={passwordFormik.values.currentPassword}
                                        />
                                        <FontAwesomeIcon
                                            icon={faEye}
                                            className={styles.loginpasswordIcon}
                                            onClick={() => setCurrentPass(!currentPass)}
                                        />
                                    </div>
                                    {passwordFormik.touched.currentPassword && passwordFormik.errors.currentPassword && (
                                        <div className={styles.errorText}>{passwordFormik.errors.currentPassword}</div>
                                    )}
                                </label>
                                <div style={{ display: 'flex', gap: '14px' }}>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Password
                                        <div className={styles.logininputContainer}>
                                            <input
                                                type={isPasswordVisible ? 'text' : 'password'}
                                                name="password"
                                                placeholder="********"
                                                className={styles.addCatInput}
                                                onChange={passwordFormik.handleChange}
                                                onBlur={passwordFormik.handleBlur}
                                                value={passwordFormik.values.password}
                                            />
                                            <FontAwesomeIcon
                                                icon={faEye}
                                                className={styles.loginpasswordIcon}
                                                onClick={() => setPasswordVisible(!isPasswordVisible)}
                                            />
                                        </div>
                                        {passwordFormik.touched.password && passwordFormik.errors.password && (
                                            <div className={styles.errorText}>{passwordFormik.errors.password}</div>
                                        )}
                                    </label>
                                    <label className={styles.addCatLabel} style={{ width: '50%' }}>
                                        Confirm password
                                        <div className={styles.logininputContainer}>
                                            <input
                                                type={isConfirmPasswordVisible ? 'text' : 'password'}
                                                name="confirmPassword"
                                                placeholder="********"
                                                className={styles.addCatInput}
                                                onChange={passwordFormik.handleChange}
                                                onBlur={passwordFormik.handleBlur}
                                                value={passwordFormik.values.confirmPassword}
                                            />
                                            <FontAwesomeIcon
                                                icon={faEye}
                                                className={styles.loginpasswordIcon}
                                                onClick={() => setConfirmPasswordVisible(!isConfirmPasswordVisible)}
                                            />
                                        </div>
                                        {passwordFormik.touched.confirmPassword && passwordFormik.errors.confirmPassword && (
                                            <div className={styles.errorText}>{passwordFormik.errors.confirmPassword}</div>
                                        )}
                                    </label>
                                </div>


                                <button type="submit" className={styles.darkButtons} onClick={passwordFormik.handleSubmit} disabled={generalFormik.isSubmitting}>
                                    {passwordFormik.isSubmitting ? 'please wait' : "Change Password"}
                                </button>
                            </div>
                        </>
                        :
                        <div className={styles.card}>
                            <h2 className={styles.addCatH2}>Provide access to admin </h2>

                            <div className={styles.permissionbox}>
                                <span className={styles.addCatLabel} >Categories</span>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Add Categories</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('create-category')}>
                                        {
                                            data?.includes('create-category') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Edit Categories</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('edit-category')}>
                                        {
                                            data?.includes('edit-category') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Delete Categories</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('delete-category')}>
                                        {
                                            data?.includes('delete-category') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                            </div>

                            <div className={styles.permissionbox}>
                                <span className={styles.addCatLabel} >Subcategories</span>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Add SubCategories</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('create-subcategory')}>
                                        {
                                            data?.includes('create-subcategory') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Edit SubCategories</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('edit-subcategory')}>
                                        {
                                            data?.includes('edit-subcategory') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Delete SubCategories</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('delete-subcategory')}>
                                        {
                                            data?.includes('delete-subcategory') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                            </div>

                            <div className={styles.permissionbox}>
                                <span className={styles.addCatLabel} >Subcategories level 3</span>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Add SubCategories level 3</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('create-subcategorylevel3')}>
                                        {
                                            data?.includes('create-subcategorylevel3') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Edit SubCategories level 3</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('edit-subcategorylevel3')}>
                                        {
                                            data?.includes('edit-subcategorylevel3') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Delete SubCategories level 3</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('delete-subcategorylevel3')}>
                                        {
                                            data?.includes('delete-subcategorylevel3') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                            </div>

                            <div className={styles.permissionbox}>
                                <span className={styles.addCatLabel} >Attributes</span>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Add Attributes</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('create-attributes')}>
                                        {
                                            data?.includes('create-attributes') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Edit Attributes</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('edit-attributes')}>
                                        {
                                            data?.includes('edit-attributes') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Delete Attributes</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('delete-attributes')}>
                                        {
                                            data?.includes('delete-attributes') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                            </div>

                            <div className={styles.permissionbox}>
                                <span className={styles.addCatLabel} >Manufacturers</span>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Add Manufacturer</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('create-manufacturer')}>
                                        {
                                            data?.includes('create-manufacturer') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Edit Manufacturer</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('edit-manufacturer')}>
                                        {
                                            data?.includes('edit-manufacturer') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Delete Manufacturer</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('delete-manufacturer')}>
                                        {
                                            data?.includes('delete-manufacturer') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                            </div>



                            <div className={styles.permissionbox}>
                                <span className={styles.addCatLabel} >Products</span>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Add product</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('create-product')}>
                                        {
                                            data?.includes('create-product') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Edit product</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('edit-product')}>
                                        {
                                            data?.includes('edit-product') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                                <div className={styles.permissioncontainer}>
                                    <span className={styles.permissionlabel}>Delete product</span>
                                    <div style={{ cursor: 'pointer' }} onClick={() => updatePermission('delete-product')}>
                                        {
                                            data?.includes('delete-product') ?
                                                <img src='/assets/onbutton.png' alt="Logo" style={{ width: 48, height: 28 }} />
                                                :
                                                <img src='/assets/offimage.png' alt="Logo" style={{ width: 48, height: 28 }} />

                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {/* </form> */}
                </div>
                {selectedTab == 0 &&
                    <div className={styles.thumbnain}>
                        <div className={styles.profcard}>
                            <div style={{ display: "flex", flexDirection: "column", alignContent: "center", gap: "10px", padding: "10px" }}>


                                {generalFormik.values.profileImg.length > 0 ?
                                    <div style={{ display: 'flex', justifyContent: 'center' }} >
                                        <img src={generalFormik.values.profileImg[0]} style={{ width: '100%', height: 190 }} />
                                        <div className={styles.cancel_cross} onClick={() => handleRemove("profileImg")}>
                                            {closeCircle()}
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <img src='/assets/ProfilePhoto.png' style={{ width: '100%', height: 190 }} />

                                        <div className={styles.uploadImgBtn} onClick={() => thumbnailImageref.current.click()} disabled={loading}>
                                            <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M8.5625 8.18647L12.5 4.25L16.4375 8.18647" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M12.5 14.7492V4.25195" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                <path d="M20.75 14.75V20C20.75 20.1989 20.671 20.3897 20.5303 20.5303C20.3897 20.671 20.1989 20.75 20 20.75H5C4.80109 20.75 4.61032 20.671 4.46967 20.5303C4.32902 20.3897 4.25 20.1989 4.25 20V14.75" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                            </svg>
                                            {loading ? 'please wait...' : 'Upload Photo'}
                                        </div>
                                        <input type="file" name="" id=""
                                            ref={thumbnailImageref}
                                            style={{ display: 'none' }}
                                            onChange={(e) => handleImageChange(e, 'profileImg', 'profileImg')}
                                            accept="image/*"
                                        />
                                        <p className={styles.addCatLabel} style={{ textAlign: "center" }}>Image size should be under 1MB and image ration needs to be 1:1</p>
                                    </>
                                }
                            </div>
                        </div>
                    </div>
                }
            </div>

            {showSuccessModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 10000,
                }}>
                    <div style={{
                        backgroundColor: '#ffffff',
                        padding: '30px',
                        borderRadius: '12px',
                        boxShadow: '0px 10px 30px rgba(0, 0, 0, 0.15)',
                        width: '90%',
                        maxWidth: '400px',
                        textAlign: 'center',
                    }}>
                        <h3 style={{
                            marginTop: 0,
                            color: '#1A1A1A',
                            fontSize: '20px',
                            fontWeight: 600,
                            marginBottom: '12px',
                        }}>Password Updated</h3>
                        <p style={{
                            color: '#666666',
                            fontSize: '14px',
                            marginBottom: '24px',
                        }}>Please log in again.</p>
                        <button onClick={handleLogout} style={{
                            backgroundColor: '#000000',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '6px',
                            padding: '12px 24px',
                            fontSize: '14px',
                            fontWeight: 500,
                            cursor: 'pointer',
                            width: '100%',
                        }}>
                            Log In
                        </button>
                    </div>
                </div>
            )}
        </>
    );
};

export default AccountSetting;












